import React from "react";
import { Popconfirm, Button, message, Space } from "antd";
import { CONTROL_ACTION_TYPE } from "../utils";
import Service, { ElAdminEventLogService } from "../services";

const ActionButtonGroups = ({ actionDetails, setActionDetails }) => {
  const onStartClicked = () =>
    setActionDetails({
      ...actionDetails,
      actionType: CONTROL_ACTION_TYPE["Start Trade"],
      isTradeAll: false,
    });

  const onCloseClicked = () =>
    setActionDetails({
      ...actionDetails,
      actionType: CONTROL_ACTION_TYPE["Close Position"],
    });

  const { account, exchangeId, symbol, sessionName } = actionDetails;

  return (
    <Space>
      <Button onClick={onStartClicked}>Trade</Button>
      <Popconfirm
        style={{ width: "200px" }}
        title={`pause execution for account: ${account} (${exchangeId} - ${symbol.split("/")[0]})？`}
        onConfirm={async () => {
          try {
            if (!sessionName) {
              throw new Error("Can't find sessionName for this trade session");
            }
            const stopTradeExecutionResult = await Service.stopTradeExecution(actionDetails);
            message.success(stopTradeExecutionResult);
            ElAdminEventLogService.saveTradeActionEvent(actionDetails);
          } catch (error) {
            // console.error(error);
            message.error(error.message ? error.message : String(error));
          }
        }}
        okText="Confirm"
        cancelText="Cancel"
      >
        <Button>Pause</Button>
      </Popconfirm>
      <Button onClick={onCloseClicked}>Empty</Button>
    </Space>
  );
};

export default ActionButtonGroups;
